var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"feature-details",attrs:{"active":_vm.active,"width":600,"scroll":"keep"},on:{"update:active":function($event){_vm.active=$event}}},[_c('div',{staticClass:"card",staticStyle:{"height":"78vh","margin-left":"12px"}},[_c('vue-good-table',{attrs:{"columns":[
        { label: _vm.localization('app-index','Index'), field: 'key' },
        { label: _vm.localization('app-serial-num','Serial Num'), field: 'value' } ],"rows":_vm.data,"search-options":{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,
        placeholder: _vm.localization('app-search-this-table','Search this table'),
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: 10,
        position: 'top',
        perPageDropdown: [10, 25, 50],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: _vm.localization('app-next', 'Next'),
        prevLabel: _vm.localization('app-prev', 'Prev'),
        rowsPerPageLabel: _vm.localization('app-rows-per-page', 'Rows per page'),
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'key', type: 'asc' },
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }